import Vue, { WatchOptions } from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import InputBase from '@/components/inputs/base/InputBase';
// tslint:disable-next-line: no-var-requires
const VueInputMask = require('vue-inputmask').default;
// tslint:disable-next-line: no-var-requires
const Inputmask = require('inputmask');

Vue.use(VueInputMask);

@Component
export default class InputMaskedText extends InputBase<string> {

  /**
   * Complete list of mask config can be found here:
   * https://github.com/RobinHerbots/Inputmask/blob/5.x/lib/inputmask.js
   */
  @Prop() public maskConfig?: object;
  @Prop() public initialValue?: string;
  @Prop() public option?: string;
  @Prop() public inputMode?: string;
  protected isComplete: boolean = false;

  protected mounted() {
    this.inputType = 'text';
    this.isComplete = false;
  }

  protected maskCheck(field: any): void {
    this.isComplete = field.target.inputmask.isComplete();
    this.$emit('input-masked-is-valid', this.isComplete);
  }

  /**
   * Override onValueChanged from InputBase
   */
  protected onValueChanged(value: string, oldValue: string) {
    if (oldValue !== value && value !== undefined) {
      const isValid = Inputmask(this.maskConfig).isValid(value);
      if (isValid) {
        this.isComplete = true;
        this.$emit('input-masked-is-valid', this.isComplete);
      }
    }
  }

  protected onFocus() {
    if (!this.value) {
      this.$emit('input', this.initialValue);
    }
  }
  protected onBlur(event: any) {
    // Read the raw unmasked value straight from the live Inputmask instance
    // (not this.value, which can already hold the mask's placeholder-padded
    // display string). If the user hasn't entered anything meaningful — either
    // the field was left as the auto-filled hint ("756"), or the user typed
    // something and erased it back down to nothing — reset it to null so it's
    // treated as "not provided" server-side, instead of leaving a leftover
    // value (e.g. "756" or "") that fails the backend's format check.
    // A genuinely incomplete/invalid number the user actually typed (e.g.
    // "75622") is left untouched so the existing validation can flag it.
    const inputmask = event.target && event.target.inputmask;
    if (inputmask) {
      const unmasked = inputmask.unmaskedvalue();
      // Compare digits only: unmaskedvalue() strips mask literals (e.g. the
      // dots), so this stays correct regardless of whether initialValue is
      // written as plain digits ("756") or includes mask literals ("756.").
      const initialDigits = (this.initialValue || '').replace(/\D/g, '');
      if (unmasked === '' || unmasked === initialDigits) {
        this.$emit('input', null);
      }
    }
  }
}
